import React from 'react';
import ReactDOM from 'react-dom/client';
// Import Swiper styles
import 'swiper/css';

import './index.css';
import './indexresponsive.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


